import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.span`
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`;

const Namespace = styled.span`
  color: var(--if-ink-3);
  font-weight: 400;
`;

const Name = styled.span`
  color: var(--if-ink-1);
  font-weight: 600;
`;

const PREFIX_MAP = {
  'location_settings_schema.': 'location.',
  'location_settings_attributes.': 'location.',
  'global_settings_attributes.': 'global.',
  'global_settings_schema.': 'global.',
  'local_settings_attributes.': 'local.',
};

function shortenField(field) {
  const entries = Object.entries(PREFIX_MAP);
  for (let i = 0; i < entries.length; i += 1) {
    const [long, short] = entries[i];
    if (field.startsWith(long)) {
      return short + field.slice(long.length);
    }
  }
  return field;
}

export default function FieldName({ field }) {
  const display = shortenField(field);
  const lastDot = display.lastIndexOf('.');
  if (lastDot === -1) {
    return (
      <Wrapper>
        <Name>{display}</Name>
      </Wrapper>
    );
  }

  const namespace = display.slice(0, lastDot + 1);
  const name = display.slice(lastDot + 1);

  return (
    <Wrapper>
      <Namespace>{namespace}</Namespace>
      <Name>{name}</Name>
    </Wrapper>
  );
}

FieldName.propTypes = {
  field: PropTypes.string.isRequired,
};
